<div
    class="fcp-accordion-header fcp-text-body-m"
    [ngClass]="{ 'fcp-accordion-disabled': disabled }"
    (click)="openItem()"
>
    <div class="fcp-accordion-icon-container">
        <fcp-icon
            [ngClass]="{ 'fcp-accordion-open': isOpen }"
            class="fcp-accordion-icon"
            [icon]="['fal', 'chevron-down']"
        ></fcp-icon>
    </div>

    <div class="fcp-accordion-header-content">
        <ng-content select="[fcp-accordion-header-content]"></ng-content>
    </div>
</div>
<div
    class="fcp-accordion-content fcp-text-body-s"
    [ngClass]="{ 'fcp-accordion-collapsed': !isOpen }"
    [hidden]="!isOpen"
>
    <ng-content select="[fcp-accordion-content]"></ng-content>
</div>
